<template>
    <b-card
        class="shadow-sm mb-3"
        header-class="px-3"
        body-class="px-3"
        >
        <template v-slot:header>
            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <b-badge variant="basic" class="mr-1">{{ sub.sub_code }}</b-badge>
                    <b-badge variant="advance">{{ sub.sub_type }}</b-badge>
                </div>

                <div>
                    <b-btn class="mr-2"
                        size="sm"
                        variant="dark-border"
                        @click="makeNextVersion(sub)"
                        >
                        다음버전생성
                    </b-btn>
                    <b-btn class=""
                        size="sm"
                        variant="dark-border"
                        @click="addToQuestion(sub)"
                        >
                        질문에 추가
                    </b-btn>
                </div>
            </div>
        </template>

        <div id="subdescription">{{ sub.sub_description }}</div>       
    </b-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'EditingSearchSubComponent',
    props: {
        sub: {
            required: true,
            type: Object
        }
    },
    data() {
        return {}
    },
    computed: {
        ...mapState(['question_subs']),
        question_code(){
            return this.$route.query.question_id
        },
    },
    methods: {
        async addToQuestion (sub) {           
            const x = {
                sub_code: sub.sub_code,
                sub_name: sub.sub_name,
                sub_type: sub.sub_type,
                sub_condition: sub.sub_condition,
                sub_description: sub.sub_description,
                sub_info: sub.sub_info,
                sub_data_header: sub.sub_data_header,
                sub_data_contents: sub.sub_data_contents,
                sub_priority: sub.sub_priority,
                sub_parent: sub.sub_parent,
                sub_child: sub.sub_child,
                question_code: this.question_code,
                tags: sub.tags,
                label: sub.label
            }
            await this.$store.dispatch('saveQuestionSub', x)
            await this.$store.dispatch('saveQuestionComposition')
            this.$emit('toast-success','성공','질문 내용 변경사항을 저장하였습니다.')
        },
        async makeNextVersion (sub) {
            try {
                const formData = new FormData()
                formData.append('sub_code', sub.sub_code)

                const response = await this.$axios.post('/subs/versioning', formData)
                let result = response.data
                
                if (result.code === 'success') {
                    //성공일 경우, 다시 검색 쿼리 읽으라는 event를 상위로 발생시킴
                    this.$EventBus.$emit('toast-success', '성공', result.msg)
                    this.$emit('make-next-version-success', result.sub_code)
                } else if (result.code === 'not_found_error') {
                    // this.$emit('toast-success-failure', '실패', '해당 질문이 존재하지 않습니다.')
                    this.$EventBus.$emit('toast-failure', '실패', '해당 질문이 존재하지 않습니다.')
                } else if (result.code === 'duplicateerror') {
                    this.$EventBus.$emit('toast-failure', '실패', result.msg)
                }
            } catch (error) {
                console.log(error);
            }
        }          
    }
}
</script>

<style>
</style>
